import { atom } from 'jotai';

export interface ImportJob {
  id: string;
  integrationId: string;
  workspaceId: string;
  status: 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';
  progress: number;
  startedAt: Date;
  completedAt?: Date;
}

// Active import jobs - persists across component unmounts
export const activeImportJobsAtom = atom<Map<string, ImportJob>>(new Map());

// Add a new import job
export const addImportJobAtom = atom(
  null,
  (get, set, job: ImportJob) => {
    const jobs = new Map(get(activeImportJobsAtom));
    jobs.set(job.id, job);
    set(activeImportJobsAtom, jobs);
  }
);

// Update an import job
export const updateImportJobAtom = atom(
  null,
  (get, set, { jobId, updates }: { jobId: string; updates: Partial<ImportJob> }) => {
    const jobs = new Map(get(activeImportJobsAtom));
    const existingJob = jobs.get(jobId);
    if (existingJob) {
      jobs.set(jobId, { ...existingJob, ...updates });
      set(activeImportJobsAtom, jobs);
    }
  }
);

// Remove an import job
export const removeImportJobAtom = atom(
  null,
  (get, set, jobId: string) => {
    const jobs = new Map(get(activeImportJobsAtom));
    jobs.delete(jobId);
    set(activeImportJobsAtom, jobs);
  }
);

// Get active jobs for a workspace
export const getActiveJobsForWorkspaceAtom = atom(
  (get) => {
    const jobs = get(activeImportJobsAtom);
    return (workspaceId: string) => 
      Array.from(jobs.values()).filter(job => job.workspaceId === workspaceId);
  }
);